import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=52c3abcb"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=52c3abcb&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c3abcb')) {
      api.createRecord('52c3abcb', component.options)
    } else {
      api.reload('52c3abcb', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=52c3abcb", function () {
      api.rerender('52c3abcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/system-components/dialog/dialog.vue"
export default component.exports